import { Component, Inject, OnInit } from '@angular/core';


import { MensajeComponent } from 'src/app/mensaje/mensaje.component';


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';


import { OrdenDataService } from 'src/app/service/data/orden-data.service';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';
import { Router } from '@angular/router';
import { Localidad } from 'src/app/models/localidad.model';
import { TicketDataService } from 'src/app/service/data/ticket-data.service';


@Component({
    selector: 'app-cantidad-boletas',
    templateUrl: './cantidad-boletas.component.html',
    styleUrls: ['./cantidad-boletas.component.css'],
    standalone: false
})
export class CantidadBoletasComponent implements OnInit {

  //Datos enviados desde componente Mapa necesarios para generar oden
  localidad: Localidad;
  cliente: ClientePagos
  eventoId: number;
  
  cantidadTickets: number //Variable para guardar cantidad de tickets en la orden

  idTicketPadre: number //Este se pasa solamente cuando se hace la compra de tickets de palco indivudual
  cantidadDisponibles:number
  //Variables auxiliares
  cargando: boolean
  cantidadPalcosDisponibles: number
  codigoVenta
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ordenService: OrdenDataService,
    private dialog: MatDialog,
    private router: Router,
    private dialogRef:MatDialogRef<CantidadBoletasComponent>,
    private ticketService: TicketDataService

  ) { }

  ngOnInit(): void {

    this.localidad = this.data.localidad
    this.cliente = this.data.cliente
    this.eventoId = this.data.eventoId
    this.cantidadTickets = 1


    this.cargando = false

    //Si este componente es llamado desde la compra de un palco, se inicializa la siguiente variable
    if (this.data.cantidadPalcosDisponibles) {
      this.cantidadPalcosDisponibles = this.data.cantidadPalcosDisponibles;
      this.idTicketPadre = this.data.idTicketPadre;
    }
    if (this.data.cantidadPalcosDisponibles == -1) {
      this.cantidadPalcosDisponibles = 0
    }
    if(this.data.codigoVenta){
      this.codigoVenta = this.data.codigoVenta
    }
    this.contarTicketsDeLocalidad()
  }

  contarTicketsDeLocalidad(): void{
    this.ticketService.contarTicketsDisponiblesDeLocalidad(this.localidad.id,0).subscribe({
      next:(response)=>
      {
        this.cantidadDisponibles = response.cantidad
      }
    })
  }

  mas() {
    if (this.data.cantidadPalcosDisponibles) {
      if (this.cantidadTickets < this.cantidadPalcosDisponibles) {
        this.cantidadTickets++;
      }
      else {
        this.mensaje('Maximo puedes comprar ' + this.cantidadPalcosDisponibles + ' Tickets');
      }
    }
    
    else {
      if(this.cantidadDisponibles){
        if(this.cantidadTickets<this.cantidadDisponibles && this.cantidadTickets<7 ){
          this.cantidadTickets++;
        }
        else if(this.cantidadTickets==7) {
          this.mensaje('Maximo puedes comprar 7 Tickets por orden');
        }
      } 
  
    }
  }

  menos() {
    if (this.cantidadTickets > 1) {
      this.cantidadTickets--;
    }
    else {
      this.mensaje('Minimo tienes que comprar 1 Ticket');
    }
  }

  cerrar() {
    this.dialogRef.close(false)
  }

  siguiente() {
    this.dialogRef.close(true)
    this.cargando = true;
  
    // Si estamos comprando un palco, usamos el nuevo método
    if (this.data.cantidadPalcosDisponibles) {

      let tipo: number = (this.localidad.tipo == 1 || this.localidad.tipo == 3) ? 4 : 2;


      if(!this.codigoVenta){
      this.ordenService.crearOrdenPalcoIndividual(this.eventoId, this.cliente.numeroDocumento, this.idTicketPadre, this.cantidadTickets, tipo).subscribe({
        next: response => {
          if (response.ordenId) {
            this.dialog.closeAll();
            this.router.navigate([`/eventos/carrito/${response.ordenId}`]);
          } else if (response.mensaje) {
            this.mensaje(response.mensaje);
            this.cargando = false;
          }
        },
        error: error => {
          this.cargando = false;

          this.mensaje('Hubo un error al procesar tu solicitud. Por favor, intenta de nuevo.');
        }
      });
    }
    else{
      this.ordenService.crearOrdenPalcoIndividualPromotor(this.eventoId, this.cliente.numeroDocumento, this.idTicketPadre, this.cantidadTickets,this.codigoVenta, tipo).subscribe({
        next: response => {
          if (response.ordenId) {
            this.dialog.closeAll();
            this.router.navigate([`/eventos/carrito/${response.ordenId}`]);
          } else if (response.mensaje) {
            this.mensaje(response.mensaje);
            this.cargando = false;
          }
        },
        error: error => {
          this.cargando = false;

          this.mensaje('Hubo un error al procesar tu solicitud. Por favor, intenta de nuevo.');
        }
      });
    }

    } else {
      // Método original para comprar tickets normales
      let tipo: number = (this.localidad.tipo == 1 || this.localidad.tipo == 3) ? 4 : 1;
  

      if(!this.codigoVenta){
      this.ordenService.crearOrdenClienteCompra(this.cantidadTickets, this.localidad.id, tipo, this.eventoId, this.cliente).subscribe({
        next: response => {
          if (response.ordenId) {
            this.dialog.closeAll();
            this.router.navigate([`/eventos/carrito/${response.ordenId}`]);
          } else if (response.mensaje) {
            this.mensaje(response.mensaje);
            this.cargando = false;
          }
        },
        error: error => {
          this.cargando = false;

          this.mensaje('Hubo un error al procesar tu solicitud. Por favor, intenta de nuevo.');
        }
      });

    }
    else {
      this.ordenService.crearOrdenClienteCompraPromotor(this.cantidadTickets, this.localidad.id, tipo, this.eventoId, this.cliente,this.codigoVenta).subscribe({
        next: response => {
          if (response.ordenId) {
            this.router.navigate([`/eventos/carrito/${response.ordenId}`])
          }
          else if (response.mensaje) {
            this.mensaje(response.mensaje)
          }


        }, error: error => {

        }
      })
    }

    }
  }

  mensaje(mensaje): void {
    const dialogRef = this.dialog.open(MensajeComponent, {

      width: '600px',
      height: '250px',
      data: {
        mensaje: mensaje,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}